import { ValidateProperty } from "../../../../models/utilities/validate-property";

export class ShipOrderCommand {

    @ValidateProperty({ required: true })
    public orderId: string = '';

    public freight: number|null = 0.0;

    @ValidateProperty({ required: true, maxLength: 50 })
    public trackingNumber: string|null = null;
}